import { appIdentity } from "@mideye/design-tokens";

export const INSIGHT_APP_NAME = "Mideye Insight";

export function InsightAppIcon() {
  return (
    <svg viewBox={appIdentity.icon.viewBox} fill="currentColor" aria-hidden="true">
      <path d={appIdentity.apps.dashboard.icon.path} />
    </svg>
  );
}
